module.exports = __webpack_public_path__ + "img/water.89d18d5c.svg";